import { UnlistedBerthReservation as ServerUnlistedBerthReservation, UnlistedBerthReservationOptions } from 'server/models/UnlistedBerthReservation';
import { PierMark } from 'data/models/PierMark';

export { UnlistedBerthReservationData, UnlistedBerthReservationOptions } from 'server/models/UnlistedBerthReservation';

export class UnlistedBerthReservation extends ServerUnlistedBerthReservation {
    PierMark : PierMark;

    constructor();
    constructor(data : UnlistedBerthReservationOptions);
    constructor(data : UnlistedBerthReservationOptions | null = null) {
        super(data || { Id: 0 });
        this.PierMark = new PierMark(this.Footmark, this.Berth);
    }
}



// WEBPACK FOOTER //
// ./data/models/UnlistedBerthReservation.ts